<template>
  <div>
    <!-- 问题 -->
    <div class="answer-question">
      <img class="clearfix" src="@/images/dx.png" alt srcset v-show="subject.type == 0" />
      <img class="clearfix" src="@/images/duoxuan.png" alt srcset v-show="subject.type == 1" />
      <div>{{subject.question}}</div>
    </div>
    <!-- 图片 -->
    <div class="answer-questionimg" v-show="subject.img">
      <img :src="subject.img" alt srcset />
    </div>
    <!-- 选择 -->
    <div class="select" ref="optionA" @click="banClickFlag && handleClickOption('a')">
      <img :src="questionA" alt srcset v-if="StateTypeA == 0" />
      <img :src="answerSucessUrl" alt srcset v-if="StateTypeA == 1" />
      <img :src="answerFailUrl" alt srcset v-if="StateTypeA == 2" />
      <img :src="questionASel" alt srcset v-if="StateTypeA == 3" />
      <div>{{subject.optionA}}</div>
    </div>
    <div class="select" ref="optionB" @click="banClickFlag && handleClickOption('b')">
      <img :src="questionB" alt srcset v-if="StateTypeB == 0" />
      <img :src="answerSucessUrl" alt srcset v-if="StateTypeB == 1" />
      <img :src="answerFailUrl" alt srcset v-if="StateTypeB == 2" />
      <img :src="questionBSel" alt srcset v-if="StateTypeB == 3" />
      <div>{{subject.optionB}}</div>
    </div>
    <div class="select" ref="optionC" @click="banClickFlag && handleClickOption('c')">
      <img :src="questionC" alt srcset v-if="StateTypeC == 0" />
      <img :src="answerSucessUrl" alt srcset v-if="StateTypeC == 1" />
      <img :src="answerFailUrl" alt srcset v-if="StateTypeC == 2" />
      <img :src="questionCSel" alt srcset v-if="StateTypeC == 3" />
      <div>{{subject.optionC}}</div>
    </div>
    <div class="select" ref="optionD" @click="banClickFlag && handleClickOption('d')">
      <img :src="questionD" alt srcset v-if="StateTypeD == 0" />
      <img :src="answerSucessUrl" alt srcset v-if="StateTypeD == 1" />
      <img :src="answerFailUrl" alt srcset v-if="StateTypeD == 2" />
      <img :src="questionDSel" alt srcset v-if="StateTypeD == 3" />
      <div>{{subject.optionD}}</div>
    </div>
       <div :class="show?'btn2':'btn'" v-show="subject.type == 1" @click="banConfirmFlag &&  confirmMutiSelect()">确定</div>
    <!-- 倒计时 -->
    <!-- <div class="count-down">
      <img src="@/images/djs.png" alt srcset />
      <div class="two-hours">
        <van-count-down :time="time" format="mm:ss" />
      </div>
    </div>-->
    <!-- 底部的对错数量 -->
    <div class="answer-question-amount">
      <!-- 图片数量 -->
      <div class="answer-question-amoun-error">
        <img src="@/images/zqda.png" alt srcset />
        <span>{{saveSucessTopic}}</span>
        <img src="@/images/cwda.png" alt srcset />
        <span>{{saveFailTopic}}</span>
      </div>
      <!-- 题集 -->
      <div class="answer-question-amoun-ccna">
        <img src="@/images/ccna.png" alt srcset />
        <span>{{index+1}}</span>
        <span>/{{questionList.length}}</span>
      </div>
    </div>
    
  </div>
</template>

<script>
import { CountDown } from "vant";
import { UserAnswerState, Exercises } from "@/api/training";
import { Dialog } from 'vant';
export default {
  components: {
    vanCountDown: CountDown
  },
  data() {
    return {
      time: 7200000,
      questionList:[],
      subject:'',
      selectResult:'',
      index: 0,
      addNum:0,
      questionA: require("@/images/a.png"),
      questionB: require("@/images/b.png"),
      questionC: require("@/images/c.png"),
      questionD: require("@/images/d.png"),
      questionASel: require("@/images/questionASel.png"),
      questionBSel: require("@/images/questionBSel.png"),
      questionCSel: require("@/images/questionCSel.png"),
      questionDSel: require("@/images/questionDSel.png"),
      answerSucessUrl: require("@/images/questionSucess.png"),
      answerFailUrl: require("@/images/questionFail.png"),
      StateTypeA:0,
      StateTypeB:0,
      StateTypeC:0,
      StateTypeD: 0,
      banClickFlag:true,
      show:false,
      isShowBtn:false,
      saveSucessTopic:0,
      saveFailTopic:0,
      banConfirmFlag:false
    }
  },
  created() { 
    this.requestUserAnswerState();
  },
  mounted() {
  
    //  this.requestExercises()
    //    setTimeout(() => {
    //         this.index = 1;
    //       }, 5000);
    
  },
  methods: {
    // 请求答题用户的状态
    requestUserAnswerState() {
      UserAnswerState().then(res => {
        console.log(res);
        // 将状态存入到vueX中
        // this.$store.commit("updataAnswerState", res.data.answerState);
        // this.$store.commit("updataAnswerNumber", res.data.answerNumber);
        this.index =  res.data.answerNumber - 1;

        this.requestExercises();
      });
    },
    // 请求答题列表
    requestExercises() {
      Exercises().then(res => {
        console.log(res)
        if(res.code == 200) {
          this.questionList = res.data
          this.subject = this.questionList[this.index];
        }
      });
    },
    handleClickOption(item) {
      this.saveSelectResult(item);
      if(this.subject.type == 0){//单选
        this.judgeSelectResult();
      }else if(this.subject.type == 1){//多选
          console.log("多选--------------------"+this.selectResult);
          this.show = true
          this.banConfirmFlag = true
          if(this.selectResult.search('a') == -1){
            this.StateTypeA = 0;
          }else{
            this.StateTypeA = 3;
          } 
          if(this.selectResult.search('b') == -1){
            this.StateTypeB = 0;
          }else{
            this.StateTypeB = 3;
          }

          if(this.selectResult.search('c') == -1){
            this.StateTypeC = 0;
          }else{
            this.StateTypeC = 3;
          }

          if(this.selectResult.search('d') == -1){
            this.StateTypeD = 0;
          }else{
            this.StateTypeD = 3;
          }

      }
      
    },

    //确定多选
    confirmMutiSelect(){
      if(this.selectResult.length == 1) {
        Dialog.alert({
          message: '至少选择两个答案'
        }).then(() => {
           
        });
        return false
      }
      this.judgeSelectResult();
    },
    // 保存选择结果
    saveSelectResult(item){
      // 首先将选择的结果保存
      if(this.selectResult.search(item) == -1){
        if(this.selectResult.length == 0){
          this.selectResult = item;
        }else{
          this.selectResult = this.selectResult +','+ item;
        }
      }else{
        if(this.subject.type == 1){
          if(this.selectResult.search(','+item) != -1){
            this.selectResult = this.selectResult.replace(','+item,'');
            console.log("多选替换之后1:"+this.selectResult);
          }else if(this.selectResult.search(item+',') != -1){
            this.selectResult = this.selectResult.replace(item+',','');
            console.log("多选替换之后2:"+this.selectResult);
          }else if(this.selectResult.search(item) != -1){
            this.selectResult = this.selectResult.replace(item,'');
            console.log("多选替换之后3:"+this.selectResult);
          }else{
            console.log("多选替换之后4:"+this.selectResult);
          }
        }
      }
    },
    // 判断该选项是否选择正确
    judgeSelectResult(){
      let isRightA = false;
      // 判断A选项
      if(this.subject.rightAnswers.search('a') != -1 && this.selectResult.search('a') != -1 ){
        this.StateTypeA = 1;
        isRightA = true;

      }else if(this.subject.rightAnswers.search('a') == -1 && this.selectResult.search('a') != -1 ){
        this.StateTypeA = 2;
        isRightA = false;

      }else if(this.subject.rightAnswers.search('a') != -1 && this.selectResult.search('a') == -1 ){
        this.StateTypeA = 1;
        isRightA = false;

      }else if(this.subject.rightAnswers.search('a') == -1 && this.selectResult.search('a') == -1 ){
        this.StateTypeA = 0;
        isRightA = true;
      }

      let isRightB = false;
      //判断B选项
      if(this.subject.rightAnswers.search('b') != -1 && this.selectResult.search('b') != -1 ){
        this.StateTypeB = 1;
        isRightB = true;
      }else if(this.subject.rightAnswers.search('b') == -1 && this.selectResult.search('b') != -1 ){
        this.StateTypeB = 2;
        isRightB = false;
      }else if(this.subject.rightAnswers.search('b') != -1 && this.selectResult.search('b') == -1 ){
        this.StateTypeB = 1;
        isRightB = false;
      }else if(this.subject.rightAnswers.search('b') == -1 && this.selectResult.search('b') == -1 ){
        this.StateTypeB = 0;
        isRightB = true;
      }
      let isRightC = false;
      // 判断C选项
      if(this.subject.rightAnswers.search('c') != -1 && this.selectResult.search('c') != -1 ){
        this.StateTypeC = 1;
        isRightC = true;
      }else if(this.subject.rightAnswers.search('c') == -1 && this.selectResult.search('c') != -1 ){
        this.StateTypeC = 2;
        isRightC = false;
      }else if(this.subject.rightAnswers.search('c') != -1 && this.selectResult.search('c') == -1 ){
        this.StateTypeC = 1;
        isRightC = false;
      }else if(this.subject.rightAnswers.search('c') == -1 && this.selectResult.search('c') == -1 ){
        this.StateTypeC = 0;
        isRightC = true;
      }

      let isRightD = false;
      //判断D选型
      if(this.subject.rightAnswers.search('d') != -1 && this.selectResult.search('d') != -1 ){
        this.StateTypeD = 1;
        isRightD = true;
      }else if(this.subject.rightAnswers.search('d') == -1 && this.selectResult.search('d') != -1 ){
        this.StateTypeD = 2;
        isRightD = false;
      }else if(this.subject.rightAnswers.search('d') != -1 && this.selectResult.search('d') == -1 ){
        this.StateTypeD = 1;
        isRightD = false;
      }else if(this.subject.rightAnswers.search('d') == -1 && this.selectResult.search('d') == -1 ){
        this.StateTypeD = 0;
        isRightD = true;
      }

      if(isRightA && isRightB && isRightC && isRightD){
        console.log("答案正确")
        this.saveSucessTopic++     
      }else{
         console.log("答案错误")
         this.saveFailTopic++
      }
      this.banClickFlag = false;
      setTimeout(() => {
        this.gotoNextSubject();
      }, 2000);
    },

    gotoNextSubject(){
        this.index ++;
        if(this.index < this.questionList.length){
          this.subject = this.questionList[this.index];
          this.StateTypeA = 0;
          this.StateTypeB = 0;
          this.StateTypeC = 0;
          this.StateTypeD = 0;
          this.selectResult = '';
          this.show = false;
          this.banConfirmFlag = false
          this.banClickFlag = true;
        }
        if(this.index >= this.questionList.length) {
            sessionStorage.setItem('saveSucessTopic',this.saveSucessTopic)
            sessionStorage.setItem('saveFailTopic',this.saveFailTopic)
            this.$router.push({
               path:'/answerresult'
            })
        }
    }
  }
}
</script>

<style scoped lang="scss">
// 问题
.answer-question {
  width: 100%;
  height: 100%;
  padding: 20px 15px;
  box-sizing: border-box;
  color: #333333;
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  img {
    width: 40px;
    height: 20px;
    float: left;
    margin-right: 10px;
  }
}
// 实例问题图片
.answer-questionimg {
  width: 350px;
  height: 140px;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }
}
// 选择ABCD
.select {
  padding: 10px 15px;
  height: 100%;
  // padding-top: 20px;
  box-sizing: border-box;
  text-align: left;
  color: #333333;
  font-size: 16px;
  line-height: 1.5;
  position: relative;
  img {
    width: 33px;
    height: 33px;
    // float: left;
    position: absolute;
    margin-right: 10px;
    vertical-align: middle;
  }
  div {
    width: 300px;
    margin-top: 6px;
    margin-left: 40px;
  }
}
.btn {
  width: 350px;
  height: 44px;
  // background: -webkit-linear-gradient(left, #4BADF5, #398df7);
  background-color: #7dd6ff;
  opacity: 0.5;
  margin: 0 auto;
  border-radius: 22px;
  font-size: 16px;
  color: $white-color;
  line-height: 44px;
  margin-top: 50px;
  text-align: center;
}
.btn2 {
  width: 350px;
  height: 44px;
  background: -webkit-linear-gradient(left, #4badf5, #398df7);
  margin: 0 auto;
  border-radius: 22px;
  font-size: 16px;
  color: $white-color;
  line-height: 44px;
  margin-top: 50px;
  text-align: center;
}
 // 倒计时
.count-down {
  position: absolute;
  right: 13px;
  margin-top: 135px;
  width: 95px;
  height: 49px;
  img {
    width: 95px;
    height: 49px;
  }
  .two-hours {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -5px;
    margin-top: -3px;
  }
}
// 底部对错数量的展示
.answer-question-amount {
  width: 100%;
  // height: 50px;
  border-top: 1px solid #eeeeee;
  position: absolute;
  bottom: 0;
  padding: 10px 15px;
  box-sizing: border-box;
  // 对错数量
  .answer-question-amoun-error {
    float: left;
    text-align: left;
    // width: 50%;
    // height: 50px;
    img {
      width: 15px;
      height: 15px;
      vertical-align: middle;
      &:last-of-type {
        margin-left: 10px;
      }
    }
    span {
      font-size: 12px;
      margin-left: 5px;
      display: inline-block;
      box-sizing: border-box;
      vertical-align: middle;
      &:first-of-type {
        color: #008cff;
      }
      &:last-of-type {
        color: #ff6666;
      }
    }
  }

  // 题集
  .answer-question-amoun-ccna {
    float: right;
    img {
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
    span {
      font-size: 12px;
      margin-left: 5px;
      display: inline-block;
      box-sizing: border-box;
      vertical-align: middle;
      &:first-of-type {
        color: #333333;
      }
      &:last-of-type {
        color: #999999;
      }
    }
  }
}
</style>
<style lang="scss">
.van-count-down {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}
</style>
